module.exports = __webpack_public_path__ + "static/media/refresh.6c49d3fb.svg";